"use strict";
import "src/decidim/signature_collection/application";
import "src/decidim/signature_collection/identity_selector_dialog";
import "src/decidim/signature_collection/scoped_type";
require.context("../images", true);
import "stylesheets/signature_collection.scss";
